// Contact dialog: [data-contact] opens it (optionally preselecting
// data-contact-subject). "Other" reveals a free-text subject. Sends the form
// (with attachments) as multipart to POST /contact.
import { fileError, formError } from '../lib/contact'

const dialog = document.querySelector<HTMLDialogElement>('#contact-dialog')

if (dialog) {
  const form = dialog.querySelector<HTMLFormElement>('[data-contact-form]')!
  const subject = form.querySelector<HTMLSelectElement>('[data-contact-subject]')!
  const other = form.querySelector<HTMLElement>('[data-contact-other]')!
  const otherInput = other.querySelector<HTMLInputElement>('input')!
  const files = form.querySelector<HTMLInputElement>('[data-contact-files]')!
  const error = form.querySelector<HTMLElement>('[data-contact-error]')!
  const submit = form.querySelector<HTMLButtonElement>('[data-contact-submit]')!
  const fields = form.querySelector<HTMLElement>('[data-contact-fields]')!
  const done = form.querySelector<HTMLElement>('[data-contact-done]')!

  const showError = (message: string | null) => {
    error.hidden = !message
    error.textContent = message ?? ''
  }

  const syncOther = () => {
    other.hidden = subject.value !== 'Other'
    otherInput.required = !other.hidden
  }

  document.addEventListener('click', (event) => {
    const trigger = (event.target as Element).closest<HTMLElement>('[data-contact]')
    if (!trigger) return
    event.preventDefault()
    trigger.closest('dialog')?.close()
    form.reset()
    fields.hidden = false
    done.hidden = true
    showError(null)
    if (trigger.dataset.contactSubject) subject.value = trigger.dataset.contactSubject
    syncOther()
    dialog.showModal()
  })

  dialog.addEventListener('click', (event) => {
    if ((event.target as Element).closest('[data-dialog-close]')) dialog.close()
  })

  subject.addEventListener('change', () => {
    syncOther()
    if (!other.hidden) otherInput.focus()
  })

  files.addEventListener('change', () => showError(fileError([...(files.files ?? [])])))

  form.addEventListener('submit', async (event) => {
    event.preventDefault()
    const email = form.querySelector<HTMLInputElement>('input[name="email"]')
    const problem =
      formError({
        email: email ? email.value : undefined,
        subject: subject.value,
        subjectOther: otherInput.value,
        message: form.querySelector<HTMLTextAreaElement>('textarea[name="message"]')!.value,
      }) ?? fileError([...(files.files ?? [])])
    if (problem) return showError(problem)

    showError(null)
    submit.disabled = true
    submit.textContent = 'Sending…'
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
      const data = await response.json().catch(() => ({}))
      if (!response.ok) throw new Error(data.error || 'Something went wrong. Please email support@nexin.si.')
      fields.hidden = true
      done.hidden = false
    } catch (e) {
      showError((e as Error).message)
    } finally {
      submit.disabled = false
      submit.textContent = 'Send message'
    }
  })
}
